import { ListItem, ListItemText, Box, ListItemButton } from '@mui/material';

interface Props {
  order: any;
}

export const PendingOrder = ({ order }: Props) => {
  const itemsCount = Array.isArray(order?.OrderItems)
    ? order.OrderItems.length
    : 0;

  return (
    <ListItem disablePadding>
      <ListItemButton>
        <ListItemText
          primary={new Date(order.createdAt).toLocaleString('en-GB')}
          secondary={`${itemsCount} позицій · ${order.status || '-'} · ${order.fullName || '-'}`}
        />

        <Box
          component="span"
          sx={{
            marginRight: '1em',
            color: 'text.primary',
          }}
        >
          {order.totalPrice} грн
        </Box>
      </ListItemButton>
    </ListItem>
  );
};
